<template>
  <v-container>
    <amplify-authenticator :auth-config="authConfig" ></amplify-authenticator>
    <amplify-sign-out></amplify-sign-out>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      authConfig: {
        usernameAttributes: 'email',
        signUpConfig: {
          header: 'MDSi Buyback',
          hideAllDefaults: true,
          defaultCountryCode: '1',
          signUpFields: [
            {
              label: 'Email',
              key: 'email',
              required: true,
              displayOrder: 1,
              type: 'string',
              signUpWith: true
            },
            {
              label: 'Name',
              key: 'name',
              required: true,
              displayOrder: 2,
              type: 'string',
              signUpWith: true
            },

            {
              label: 'Password',
              key: 'password',
              required: true,
              displayOrder: 4,
              type: 'password'
            }
          ]
        }
      },
    })
  }
</script>

<style>

</style>
